import VSnackbar from './VSnackbar'

VSnackbar.install = function install (Vue) {
  Vue.component(VSnackbar.name, VSnackbar)
}

export default VSnackbar



// WEBPACK FOOTER //
// ./src/components/VSnackbar/index.js